import { render } from "./ProductGrid.vue?vue&type=template&id=676423f6"
import script from "./ProductGrid.vue?vue&type=script&lang=js"
export * from "./ProductGrid.vue?vue&type=script&lang=js"

import "./ProductGrid.vue?vue&type=style&index=0&id=676423f6&lang=css"
script.render = render

export default script